"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_QUESTIONNAIRE = void 0;
// eslint-disable-next-line import/prefer-default-export
var UPDATE_QUESTIONNAIRE = exports.UPDATE_QUESTIONNAIRE = 'UPDATE_QUESTIONNAIRE';
//# sourceMappingURL=type.js.map